import { COUNTRY_CODES } from "constants/countryCodes";

function countryCodeToName(countryCode) {
  return COUNTRY_CODES[countryCode];
}

export default countryCodeToName;
